export default __webpack_public_path__ + "static/media/transithublogo.6cc9b736.svg";